import { Environment, Network, RecordSource, Store } from 'relay-runtime';
import { createFetcher } from 'dibs-relay-network-layer/client';
import { setupSubscriptions } from 'dibs-relay-network-layer/subscriptionsClient';
import SV from 'server-vars';
import { getBuyerToken } from 'dibs-cookie-jar';
import { getGuestUserToken } from './checkoutGuestUserToken';

type GetEnvironmentOptions = {
    getGraphQLNetworkContext?: () => string | null;
    additionalHeaders?: Record<string, string>;
};

export function getEnvironment({
    getGraphQLNetworkContext,
    additionalHeaders,
}: GetEnvironmentOptions = {}): Environment {
    const source = new RecordSource();
    const store = new Store(source);
    const userType = 'buyer';
    const getQueries: () => Record<string, string | undefined> = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const shareToken = searchParams.get('shareToken');
        const buyerToken = getBuyerToken(document.cookie);
        const emailToken = searchParams.get('emailToken') || undefined;

        // guest token takes precedence over email only tokens
        // guest token should not coexist with full account tokens so always takes precedence if it exists
        const guestUserToken = getGuestUserToken();
        const userToken = guestUserToken
            ? {
                  userToken: guestUserToken,
              }
            : buyerToken;

        const queries: Record<string, string | undefined> = {
            ...userToken,
            emailToken,
            locale: SV.get('locale'),
        };

        if (shareToken) {
            queries.invoiceAccessToken = shareToken;
        }

        return queries;
    };
    const network = Network.create(
        createFetcher({ userType, getQueries, getGraphQLNetworkContext, additionalHeaders }),
        setupSubscriptions({ getQueries, userType }).fetchOrSubscribe
    );

    return new Environment({
        network,
        store,
    });
}
